import React from 'react';

import Grid from '@material-ui/core/Grid';

import Room from './Room';

export default (props) => {
  return (
    props.config.sessions.map( (session, index) => (
      <div key={index}>
        <Grid container direction="row" spacing={5} key={index}>
          {session.rooms.map( (room, index) => (
            <Grid item md={6} key={index}>
              <Room config={room} setVideoSrc={props.setVideoSrc} />
            </Grid>
          ))}
        </Grid>
      </div>
    ))
  );
}
